jQuery(function($){
    
    var winW = $(window).width();  

    $(window).on('scroll', function() {
			
        var scrollTop = $(this).scrollTop();
            
            if (scrollTop > 150) {
                $('#pagetop').fadeIn();
            } else {
                $('#pagetop').stop().fadeOut();
            }

    });

    $('#Details-HeaderMenu-2').hover(function(){
        $(this).attr("open","");
    });

  /*
    $("#MainContent").click(function(){
        $('#Details-HeaderMenu-2').removeAttr("open");
    });
  */

    $("html").click(function(){
        $('#Details-HeaderMenu-2').removeAttr("open");
    });

  $(window).on('scroll', function(e){  
        $('#Details-HeaderMenu-2').removeAttr("open");
    });


    $('#pagetop a').on('click', function(e){
        var url = $(this).attr("href");
        var dest = url.split("#");
        var target = dest[1];
        if (typeof target != 'undefined') {
            if (typeof target != 'undefined') {
                var target_offset = $("#"+target).offset();
                if (typeof target_offset != 'undefined') {
                    $('body,html').stop(true,true).animate({scrollTop:0}, 800, 'swing');
                    e.preventDefault();
                }
            }
        }
        return true;
    });
      
    const observer = lozad();
    observer.observe();
});
window.addEventListener('load', (event) => {
    AOS.init({
        duration: 900,
        easing: 'ease-in-out-sine',
        once: true,
        offset : 0,
        disable : 'mobile'
}); 
});
